import React from 'react';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';

import withStyles from 'isomorphic-style-loader/withStyles';
import s from './StoreHeader.css';
import { Navbar, NavLink } from 'react-bootstrap';
import cx from 'classnames';

import Link from '../../../Link/Link';
import StoreNavigation from '../StoreNavigation/StoreNavigation';

import { api, storeImageUploadDir } from '../../../../config';
import chef from '../../../../../public/StoreIcon/store.svg';
import { FaBars } from 'react-icons/fa';

class StoreHeader extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isOpen: 0,
    };
    this.openMenu = this.openMenu.bind(this);
    this.openClose = this.openClose.bind(this);
  }

  openMenu() {
    this.setState({
      isOpen: 1,
    })
  }

  openClose() {
    this.setState({
      isOpen: 0,
    })
  }

  render() {
    const { shopPicture, shopName, isLogin, isOpen, isActive, socket } = this.props;


    const shopPictureUrl = shopPicture ? api.apiEndpoint + storeImageUploadDir + shopPicture : chef;
    const asapLogo = '/images/ASAP-logo.svg';

    return (
      <div className={cx(s.root, 'mainMenu', 'storeHeader', [isLogin ? 'store' : 'storeBeforeLogin'])}
        style={{ boxShadow: '0 0px 20px 0px rgba(0, 0, 0, 0.3)' }}>
        <Navbar expand="lg" className={cx(s.navBg, [isLogin ? s.storeBg : ''], [isLogin ? 'storeBgRTL' : ''])}>

          {isLogin &&
            < Navbar.Brand className={cx(s.navbarBrand, 'd-flex align-items-center')}>
              <Link className={s.brand} to={isLogin ? "/store/dashboard" : "/"}>
                <img
                  src={shopPictureUrl}
                  height={48}
                  width={48}
                  alt={"Shop Avatar"}
                  className={s.imgSection}
                />
              </Link>
              <div className='ml-2 d-inline-flex flex-column'>
                <div className='text-dark'>{shopName}</div>
                <span className={cx('small', isActive ? 'text-success' : 'text-danger')}>{isActive ? "Buka" : "Sedang Tutup"}</span>
              </div>
            </Navbar.Brand>
          }

          {!isLogin &&
            <>
              < Navbar.Brand className={cx(s.navbarBrand, 'd-flex align-items-center')}>
                <Link className={s.brand} to={"/store"}>
                  <img
                    src={asapLogo}
                    height={48}
                    alt={"ASAP Logo"}
                  />
                </Link>
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" className={cx(s.borderNone, s.outlineNone)}
                children={
                  <button type='button' className={s.menuToggle} onClick={() => this.openMenu()}>
                    <FaBars />
                  </button>
                }
              />
            </>}

          <Navbar.Collapse id="basic-navbar-nav" className={cx({ [s.menuOpened]: this.state.isOpen == 1 }, s.justifyFlexEnd, isLogin ? 'store' : s.menuClosed)} in={isOpen}>
            <div>
              <button type='button' className={cx(s.closeButton, 'closeButtonRTL')} onClick={() => this.openClose()}> &#x2715; </button>

              <StoreNavigation socket={socket} />
            </div>
          </Navbar.Collapse>

        </Navbar>
      </div >
    )
  }
}

const mapState = (state) => ({
  shopPicture: state && state.account && state.account.data && state.account.data.profile && state.account.data.profile.picture,
  shopName: state && state.account && state.account.data && state.account.data.profile && state.account.data.profile.shopName,
  isActive: state && state.account && state.account.data && state.account.data.isActive,
  siteName: state.siteSettings.data.siteName,
  isLogin: state.runtime.isStoreAuthenticated
})
const mapDispatch = {}

export default compose(withStyles(s), connect(mapState, mapDispatch))(StoreHeader)
